






































import Vue, { PropType } from 'vue';
import FieldButton from '@/components/form/FieldButton.vue';
import { TFile } from '@/types';

export default Vue.extend({
  name: 'FieldFile',
  components: { FieldButton },

  props: {
    value: {
      type: [Array, String] as PropType<Array<string> | string>,
      required: false,
      default: () => [],
    },
    accept: {
      type: String,
      required: false,
      default: '*',
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    errors: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  mounted() {
    if (this.value.length) {
      this.setFiles(this.value);
    }
  },

  watch: {
    value(newValue: Array<string> | string) {
      this.setFiles(newValue);
    },
  },

  computed: {
    fieldFile(): HTMLInputElement {
      return this.$refs.fieldFile as HTMLInputElement;
    },
  },

  methods: {
    setFiles(newValue: Array<string> | string) {
      if (!newValue) return;

      if (Array.isArray(newValue)) {
        this.files = newValue.map(n => ({ name: n, data: null }));
        return;
      }

      this.files = [{ name: newValue, data: null }];
    },
    openSelectFileFolder(): void {
      this.fieldFile.click();
    },
    async selectFiles(): Promise<void> {
      this.files = [];
      const files = this.fieldFile.files;

      if (files?.length) {
        for (let i = 0; i < files.length; i++) {
          await this.addFile(files[i]);
        }
      }

      this.fieldFile.value = '';
      this.onChange();
    },
    addFile(file: File): Promise<void> {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      return new Promise(resolve => {
        fileReader.onloadend = () => {
          const data = {
            name: file.name,
            data: file,
          } as TFile;

          this.files.push(data);
          resolve();
        };
      });
    },
    removeFile(index: number): void {
      this.files.splice(index, 1);
      this.onChange();
    },
    onChange(): void {
      this.$emit('change', this.files);
    },
  },

  data() {
    return {
      files: [] as Array<TFile>,
    };
  },
});
